import { EventEmitter, Injectable, Output } from "@angular/core";
import { API_METHODS, API_URL, OperationType } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { environment } from 'src/environments/environment';
import { FormDataService } from "../../base-data-services/form-data.service";
import { StudentAvailabilityModel } from "common/models/page-models/internship-detail/student-availability-data.model";
import moment from "moment";


@Injectable()
export class StudentAvailabilityFormDataService extends FormDataService<StudentAvailabilityModel> {

  @Output() emitResultGrid = new EventEmitter<any>();
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.StudentResponseOnInvite, http, ss);
  }

  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.StudentResponseOnInvite,
      method: API_METHODS.post
    }
    return edit;
  }

  override convertFormData(body) {
    var formData: any = new FormData();
    Object.keys(body).forEach((a) => {
      formData.append(a.toString(), body[a]);
    });
    // console.log('PAYLOAD', formData);

    return formData;
  }

  override async postData(data, isFormData: boolean = true): Promise<any> {
    return await super.postData(this.convertFormData(data), isFormData);
  }

  override modifyAPIResponse(response: any) {
    return response['details'];
  }


  // override modifyPostModel(formModel: any, dataModel: any) {
  //   // formModel.id = this.ss.student_id;
  //   console.log("FORM and daat MODEL", formModel,dataModel);
    
  //   const submitData : any = {}
  //   return submitData;
  // }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<StudentAvailabilityModel> {
    return new Promise((resolve, reject) => {
      // console.log(model, metamodel, dataModel);
      const submitData : any = {};

      submitData.id = model.id;
      submitData.isStudentAvailable = model.isStudentAvailable;
      submitData.studentExamStartDate = moment(model.semesterExamStart).format("YYYY-MM-DD");
      submitData.studentExamEndDate = moment(model.semesterExamEnds).format("YYYY-MM-DD");

      if(model.semesterExamEnds < model.semesterExamStart){
        this.ss.showError("Semester exam end date should be greater than start date");
        return;
      }
     
      submitData.studentSummerVacationStartDate = moment(model.summerVacationStarts).format("YYYY-MM-DD");
      submitData.studentSummerVacationEndDate = moment(model.summerVacationEnds).format("YYYY-MM-DD");

      if(model.summerVacationEnds < model.summerVacationStarts){
        this.ss.showError("Summer vacation end date should be greater than start date");
        return;
      }
     
      if( model.isStudentAvailable === 1){
        submitData.studentExpectedInternshipStartDate = moment(model.internshipStartDate).format("YYYY-MM-DD");
        submitData.studentExpectedInternshipEndDate = moment(model.internshipEndDate).format("YYYY-MM-DD");
      } else if(model.isStudentAvailable === 2){
        submitData.isExternalCompanyForInternship = model.isExternalCompanyForInternship;
        if(model.isExternalCompanyForInternship === 1){
          submitData.externalCompanyName = model.externalCompanyName;
          submitData.externalCompanyLocation = model.externalCompanyLocation;
          submitData.studentExpectedInternshipStartDate = moment(model.internshipStartDate).format("YYYY-MM-DD");
          submitData.studentExpectedInternshipEndDate = moment(model.internshipEndDate).format("YYYY-MM-DD");
          if(model.internshipCerty){
            submitData.internshipCerty = model.internshipCerty;
          }
        }
      }

      if(model.internshipEndDate < model.internshipStartDate){
        this.ss.showError("Internship end date should be greater than start date");
        return;
      }
      
      submitData.studentAvailabilityRemark = model.studentAvailabilityRemark;
      
      resolve(submitData);
    });
  }


  createInstance(): StudentAvailabilityModel {
    return new StudentAvailabilityModel();
  }


//   override afterPostData(model: TerminateInternshipModel, result?: any): Promise<TerminateInternshipModel> {
//     return new Promise<TerminateInternshipModel>((resolve, reject) => {
//       this.emitResultGrid.emit(result)
//       resolve(this.transformAPIData(model));
//     });
//   }


  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    
    return environment.apiUrl + this.getAPI_URL();
  }
  
}